var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/generated-form.ts
import { logger } from "@adornis/base/logging.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/datetime/x-date-picker-dropdown.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import "@adornis/file-utils/client/x-image.js";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import "@adornis/forms/x-textarea.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { GenericFieldFormController } from "./generic-field-formcontroller.js";
var GeneratedForm = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.blacklist = [];
    this.whitelist = [];
    this.layout = "field";
    this.columns = "1";
    this.placeholderMode = "inline-floating";
    this.t = new TranslationController(this);
  }
  render() {
    if (!this.formController)
      return html` <x-text>Es muss ein FormController angegeben werden</x-text>`;
    if (!(this.formController instanceof GenericFieldFormController))
      throw new Error("please pass a GenericFieldFormController instead of a normal FormController");
    if (!this.formController.document)
      return html` <x-text> Der Formcontroller muss ein Dokument beinhalten </x-text> `;
    if (!this.controls)
      return xComponents(this._generateFieldsForEntity(this.formController.document));
    return xComponents(html`
      <x-flex space="sm">
        ${this.heading ? html`
              <x-h2>
                ${this.formController.document._class}
                ${this.formController.document.isNew ? "erstellen" : "bearbeiten"}
              </x-h2>
            ` : nothing}
        ${this._generateFieldsForEntity(this.formController.document)}
        <x-flex horizontal end space="md">
          <x-button
            mode="outline"
            tone="error"
            icon="delete"
            @click=${() => XDialog.guard(async () => {
      await this.formController?.document?.remove();
      this.dispatchEvent(new CustomEvent("cancel", { detail: { value: this.formController?.document } }));
    })}
          >
            löschen
          </x-button>
          <x-button
            mode="outline"
            @click=${() => this.dispatchEvent(new CustomEvent("cancel", { detail: { value: this.formController?.document } }))}
            icon="close"
          >
            Abbrechen
          </x-button>
          <x-button icon="check" @click=${() => this.formController?.validate()}> Speichern </x-button>
        </x-flex>
      </x-flex>
    `);
  }
  _generateFieldsForEntity(entity, path = [], maxDepth = 5) {
    if (!entity || maxDepth <= 0)
      return nothing;
    let fields = Object.entries(entity.fields);
    fields = fields.filter(([name]) => !["_class", "_id"].includes(name));
    fields = fields.filter(([name, field]) => !field.options.resolve);
    if (this.whitelist.length > 0) {
      fields = fields.filter(([name]) => this.whitelist.some((whitelisted) => [...path, name].includes(whitelisted)));
    } else {
      fields = fields.filter(([name]) => !this.blacklist.some((blacklisted) => [...path, name].includes(blacklisted)));
    }
    return html`
      <x-grid
        space="sm"
        columns=${+this.columns * (this.layout === "key-field" ? 2 : 1)}
        ${css({ alignItems: "center" })}
      >
        ${fields.map(([name, fieldDef]) => {
      const arrayDepth = fieldDef.arrayDepth();
      if (arrayDepth) {
        if (arrayDepth > 1)
          throw new Error("Cannot handle more than 1D arrays");
        return this.renderArrayField(entity, name, path, fieldDef);
      }
      const pathToName = [...path, name];
      const type = fieldDef.type();
      if (type._isBaseQLEnum)
        return this.renderField({ host: this, fieldDef, pathToName });
      const scalar = Object.values(baseqlMetaData.scalars).find((s) => s.isTypeOf(type));
      if (scalar)
        return this.renderField({ host: this, fieldDef, pathToName });
      if (new type({}) instanceof AdornisEntity) {
        if (!entity[name])
          entity[name] = new type({});
        return this._generateFieldsForEntity(entity[name], pathToName, maxDepth - 1);
      }
      return this.renderField({ host: this, fieldDef, pathToName });
    })}
        <slot></slot>
      </x-grid>
    `;
  }
  renderField(options) {
    const genericField = this.formController?.genericField(options.pathToName, {
      placeholderMode: this.placeholderMode,
      plainField: this.layout === "key-field"
    });
    return this.layout === "key-field" ? [html` <x-text align="right" tone="subtle"> ${options.fieldDef.name} </x-text> `, genericField] : genericField;
  }
  renderArrayField(entity, fieldName, pathToField, fieldDef) {
    if (!entity[fieldName])
      entity[fieldName] = [];
    return html`
      <x-basic-card space="sm" padding="md">
        <x-h3>${this.t.translate("field", fieldName)} (${entity[fieldName]?.length ?? 0})</x-h3>
        ${repeat(entity[fieldName] ?? [], (entry, index) => {
      return html`
            <x-flex horizontal space="sm">
              <x-icon
                ${css({
        color: this.colors.tone.error,
        fontSize: "1.5em",
        cursor: "pointer",
        padding: ".25em",
        borderRadius: this.sizes.borderRadiusSecondary,
        width: "min-content",
        height: "min-content",
        margin: "0 auto",
        transition: "200ms"
      })}
                ${acss({
        "&:hover": {
          background: this.colors.tone.error,
          color: `${this.colors.tone.whitePrimary} !important`
        }
      })}
                tone="error"
                @click=${() => {
        entity[fieldName].splice(index, 1);
        this.requestUpdate();
      }}
              >
                delete
              </x-icon>
              <x-flex space="sm" flex>
                ${entry instanceof AdornisEntity ? this._generateFieldsForEntity(entry, [...pathToField, fieldName, index.toString()]) : this.renderField({
        host: this,
        fieldDef,
        pathToName: [...pathToField, fieldName, index]
      })}
              </x-flex>
            </x-flex>
          `;
    })}
        <x-button
          mode="outline"
          icon="add"
          @click=${async () => {
      try {
        const constr = fieldDef.type();
        const possibleSubclasses = baseqlMetaData.entities.resolveNode(constr._class).children.map((c) => c.type());
        const chosenConstr = !possibleSubclasses?.length ? constr : possibleSubclasses.length === 1 ? possibleSubclasses[0] : await XDialog.showPopup({
          content: (choose) => html`
                        <x-flex padding="md" space="sm">
                          ${possibleSubclasses.map(
            (c) => html`
                                <x-button mode="outline" icon="add" @click=${() => choose(c)}>
                                  ${this.t.translate("class", c._class)}
                                </x-button>
                              `
          )}
                        </x-flex>
                      `
        });
        if (!chosenConstr)
          return;
        let newField = new chosenConstr({});
        if (newField instanceof String)
          newField = "";
        entity[fieldName].push(newField);
        this.requestUpdate();
      } catch (err) {
        logger.error(err);
      }
    }}
        >
          ${this.t.translate("cms", "addEntry")}
        </x-button>
      </x-basic-card>
    `;
  }
};
__decorateClass([
  property({ attribute: false })
], GeneratedForm.prototype, "formController", 2);
__decorateClass([
  property({ type: Boolean })
], GeneratedForm.prototype, "controls", 2);
__decorateClass([
  property({ type: Boolean })
], GeneratedForm.prototype, "heading", 2);
__decorateClass([
  property({ attribute: false })
], GeneratedForm.prototype, "blacklist", 2);
__decorateClass([
  property({ attribute: false })
], GeneratedForm.prototype, "whitelist", 2);
__decorateClass([
  property({ attribute: true })
], GeneratedForm.prototype, "layout", 2);
__decorateClass([
  property({ attribute: true })
], GeneratedForm.prototype, "columns", 2);
__decorateClass([
  property({ attribute: "placeholder-mode" })
], GeneratedForm.prototype, "placeholderMode", 2);
__decorateClass([
  state()
], GeneratedForm.prototype, "t", 2);
GeneratedForm = __decorateClass([
  customElement("generated-form")
], GeneratedForm);
export {
  GeneratedForm
};
